export default __webpack_public_path__ + "static/media/ic_tansak.b35982f3.svg";